import { LOADING, DATA, CFD_STATS, AVG_FE, OVERVIEW_STATS, OVERVIEW_TYPE } from './OverviewActions';

const INITIAL_STATE = {
  cfd: [],
  cfdStats: [],
  cfdLoading: true,
  ctsp: [],
  ctspLoading: true,
  ctb: [],
  ctbLoading: true,
  cth: [],
  cthLoading: true,
  cta: [],
  ctaLoading: true,
  trc: [],
  trcLoading: true,
  avgFe: {}, 
};

const OverviewReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      return {
        ...state,
        cfdLoading: true,
        ctspLoading: true,
        ctbLoading: true,
        cthLoading: true,
        ctaLoading: true,
        trcLoading: true        
      };
    }
    case DATA: {
      return {
        ...state,
        [action.chart]: action.data,
        [`${action.chart}Loading`]: false,
      };
    }
    case CFD_STATS: {
      return {
        ...state,
        cfdStats: action.stats,
      };
    }
    case AVG_FE: {
      return {
        ...state,
        avgFe: action.data,
      };
    }
    case OVERVIEW_STATS: {
      return {
        ...state,
        metrics: action.data
      };
    }   
    default:
      return state;
  }
};

export default OverviewReducer;
